"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipientInfoContext = void 0;
const react_1 = require("react");
exports.RecipientInfoContext = (0, react_1.createContext)({});
